import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

// 소재등록 페이지 paper
export const DefaultItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.grey[400]}`,
}));
